<template>
  <div class="page-schedule">
    <WatchModal :show="false"/>
    <ModalZoomIframe />
    <div class="page-schedule-main">
      <Filters
          :stats="data.stats"
          :interval="data.interval"
          :days="Object.keys(data.list)"
          :length="totalEventsLength"
      />
      <div class="day-events-block" v-if="daySchedule">
        <div class="day-events-title">Upcoming events</div>
        <div class="day-events-list">
          <CompactEventBlock
              v-for="(event, index) in data.list[daySchedule]"
              :event="event"
              :key="index"
              @watch-video="watchEventVideo"
              @watch-zoom="watchZoom"
          />
        </div>
      </div>
      <div
          :is="daySchedule ? 'div' : 'vue-double-scrollbar'"
          v-bind="{ [daySchedule ? 'class' : 'class-name']: ['schedule', { day: daySchedule }] }"
          :watch="data"
          ref="container"
      >
        <div class="col" v-for="(dayEvents, date, i) in dataList" :key="date" ref="col">
          <div class="day-col">
            <router-link tag="div" :to="{ params: { day: date } }" class="head">
              <div class="date">{{ getDate(date) }}</div>
              <div class="weekday">{{ getWeekday(date) }}</div>
            </router-link>
            <router-link
                v-if="daySchedule && getNextDate(date)"
                tag="div"
                :to="{ params: { day: getNextDate(date) } }"
                class="head next-day"
            >
              <div class="date">{{ getNextDateStr(date) }}</div>
              <img src="@/assets/icons/arrow-gray.svg" alt=""/>
            </router-link>
          </div>
          <ListEvents
              :list="dayEvents"
              :extreme="i >= extremeIndex"
              @watch-video="watchEventVideo"
              @watch-zoom="watchZoom"
              :large="!!daySchedule"
          />
        </div>
<!--        <div class="col">-->
<!--          <div class="day-col">-->
<!--            <router-link tag="div" :to="{ params: { day: 1677099600000 } }" class="head">-->
<!--              <div class="date">{{ getDate(1677099600000) }} • {{ getDate(1677186000000, 'DD')}}</div>-->
<!--              <div class="weekday">{{ getWeekday(1677099600000) }} • {{ getWeekday(1677186000000) }}</div>-->
<!--            </router-link>-->
<!--            <router-link-->
<!--                v-if="daySchedule && getNextDate(1677099600000)"-->
<!--                tag="div"-->
<!--                :to="{ params: { day: getNextDate(1677099600000) } }"-->
<!--                class="head next-day"-->
<!--            >-->
<!--              <div class="date">{{ getNextDateStr(1677099600000) }}</div>-->
<!--              <img src="@/assets/icons/arrow-gray.svg" alt=""/>-->
<!--            </router-link>-->
<!--          </div>-->
<!--          <EventB2B :event="datab2b" extreme @watch-zoom="watchZoom"/>-->
<!--        </div>-->
      </div>

    </div>
    <div class="page-schedule-side hide-mobile" v-if="daySchedule">
      <ActiveEventPanel v-if="daySchedule" :event="activeEvent"/>
    </div>
  </div>
</template>

<script>
import ListEvents from '@/components/events/ListEvents'
import Filters from '@/components/schedule/Filters'
import moment from 'moment'
import getEvents from '@/mixins/getEvents'
import {splitEventsByDay} from '@/utils/data'
import _throttle from 'lodash/throttle'
import vueDoubleScrollbar from '@/components/schedule/double-scrollbar'
import CompactEventBlock from '@/components/schedule/CompactEventBlock'
import VideoPlayer from '@/components/ui/VideoPlayer'
import UserVideo from '@/components/user/UserVideo'
import MainSponsors from '@/components/MainSponsors'
import Avatar from '@/components/user/Avatar'
import ActiveEventPanel from '@/components/schedule/ActiveEventPanel'
import WatchModal from "@/components/WatchModal";
import {$vfm} from "vue-final-modal";
import ModalZoomIframe from "@/components/modals/ModalZoomIframe";
import EventB2B from "@/components/events/EventB2B";
import RightNow from "@/components/RightNow";

export default {
  name: 'Schedule',
  components: {
    RightNow,
    EventB2B,
    ModalZoomIframe,
    WatchModal,
    ActiveEventPanel,
    Avatar,
    MainSponsors,
    UserVideo,
    VideoPlayer,
    CompactEventBlock,
    Filters,
    ListEvents,
    vueDoubleScrollbar,
  },
  mixins: [getEvents],
  data: () => ({
    extremeIndex: 2,
    container: false,
    activeEventId: null,
  }),
  mounted() {
    this.calcExtremeIndex()
    this.$nextTick(() => {
      this.container = this.$refs.container.$refs.scrollArea
      this.container.addEventListener(
          'scroll',
          _throttle(() => {
            this.calcExtremeIndex()
          }, 500),
          {passive: true}
      )
      this.initScroll()
    })
  },
  computed: {
    totalEventsLength() {
      return Object.values(this.data.list).reduce((totalLength, list) => {
        return totalLength + list.length
      }, 0)
    },
    data() {
      return splitEventsByDay(this.events)
    },
    datab2b() {
      return splitEventsByDay(this.b2b)
    },
    dataList() {
      if (this.daySchedule) {
        return {[this.daySchedule]: this.data.list[this.daySchedule]}
      } else {
        return this.data.list
      }
    },
    daySchedule() {
      return +this.$route.params.day
    },
    activeEvent() {
      return this.events.find((event) => event.id === this.activeEventId)
    },
  },
  watch: {
    events() {
      this.activeEventId = this.events[0]?.id
    },
  },
  methods: {
    isPC() {
      return window.matchMedia('(min-width: 768px)').matches
    },
    watchZoom(event) {
      $vfm.show('zoomModalIframe', {
        resource: event,
        zoom: {},
      })
    },

    watchEventVideo(event) {
      if(event.video_link) {
        $vfm.show('watchModal', {
          resource: event
        })
      } else {
        this.$toast({ title: 'Video not available' })
      }

      //
      // this.activeEventId = event.id
      // // this.$router.push({ name: 'ScheduleEvent', params: { event: event.id, name: event.name } })
      // console.log('log')
      // if (this.isPC()) {
      //   console.log('is pc')
      // } else {
      //   console.log('push')
      //   this.$router.push({name: 'ScheduleEvent', params: {event: event.id, name: event.name}})
      // }
    },

    initScroll() {
      let unwatch = this.$watch(
          'data',
          (data) => {
            if (data && data.list && unwatch) {
              unwatch()
              this.goToDay(this.getCurrentDayIndex(data.list))
            }
          },
          {deep: true, immediate: true}
      )
    },
    goToDay(i) {
      this.container.scrollLeft = this.getColWidth() * i
    },
    getCurrentDayIndex(listDays) {
      const curDay = moment().startOf('day')
      const days = Object.keys(listDays)
      const i = days.findIndex((timestamp) => timestamp >= curDay)
      if (~i) return i
      else return days.length - 1
    },
    getColWidth() {
      const {col} = this.$refs
      if (col) {
        const colMargin = 22
        return col[0].offsetWidth + colMargin
      }
      return 1
    },
    calcExtremeIndex() {
      if (this.container) {
        const scrollPos = this.container.offsetWidth + this.container.scrollLeft
        this.extremeIndex = Math.round(scrollPos / this.getColWidth() - 0.75)
      }
    },
    getDate(date, format = 'MMM DD') {
      return moment(+date).format(format)
    },

    getNextDate(date) {
      const list = Object.keys(this.data.list)
      return +list.find((timestamp) => timestamp > date)
    },

    getNextDateStr(date) {
      return moment(this.getNextDate(date)).format('MMM DD')
    },

    getWeekday(date) {
      return moment(+date).format('dddd')
    },
  },
}
</script>

<style lang="scss">
.page-schedule {
  display: flex;
  min-height: calc(100vh - 161px);

  @include mobile {
    padding: 22px 0 !important;
  }

  .page-schedule-main {
    width: 100%;
    min-width: 0;

    .day-col {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .page-schedule-side {
    position: sticky;
    top: 20px;
    display: flex;
    flex-direction: column;
    width: 364px;
    height: calc(100vh - 94px);
    flex-shrink: 0;
    margin-left: 43px;
  }

  .day-events-block {
    margin-top: 30px;
    margin-bottom: 15px;

    @include mobile {
      padding: 0 20px;
      margin-top: 20px;
      margin-bottom: 40px;
    }

    .day-events-title {
      margin-bottom: 9px;
      font-weight: 700;
      font-size: 15px;
      line-height: 20px;
      color: #474747;

      @include mobile {
        margin-bottom: 20px;
      }
    }

    .day-events-list {
      display: flex;
      overflow-x: auto;
      margin-left: 4px;

      @include mobile {
        margin: 0 -20px;
        padding: 0 20px;
      }
    }
  }

  .schedule {
    display: flex;
    max-width: 100%;
    padding-top: 15px;

    @include mobile {
      padding: 0 9px;

      &.day {
        padding: 0 20px;

        .col {
          margin: 0;
        }
      }
    }

    &.day {
      flex-direction: column;

      .col {
        width: 100%;
      }
    }

    .col {
      width: 224px;
      flex-shrink: 0;
      margin-right: 22px;

      &:last-child .event-block .rating-block .dropdown {
        left: unset;
        right: -24px;

        &::before {
          left: unset;
          right: 25px;
        }
      }

      @include mobile {
        margin: 0 11px;
      }

      @include PC {
        width: 280px;
      }

      .day-col {
        > .head {
          display: flex;
          align-items: center;
          line-height: 1;
          margin-bottom: 20px;
          cursor: pointer;

          .date {
            font-weight: bold;
            font-size: 16px;
            margin-right: 7px;

            @include PC {
              margin-right: 12px;
            }
          }

          .weekday {
            font-weight: bold;
            font-size: 12px;
            color: $dark;
          }
        }

        > .next-day {
          .date {
            font-weight: 700;
            font-size: 12px;
            line-height: 147.5%;
            color: $dark;
          }
        }

        .next-day {
          @include mobile {
            background: $white;
            padding: 7px 15px;
            box-shadow: 0px 4.49832px 21.367px rgba(0, 0, 0, 0.06);
            border-radius: 5px;
            margin-right: 20px;
          }
        }
      }
    }
  }
}
</style>
